import { css } from 'styled-components';
import * as base from './base';
import * as lightTheme from '../generated/themes/semantic/light-theme';
import * as darkTheme from '../generated/themes/semantic/dark-theme';

export const cssVariables = css`
  ${base.cssVariables}
  ${lightTheme.cssVariables}
  @media (prefers-color-scheme: dark) {
    ${darkTheme.cssVariables}
  }
`;

export const theme = {
  ...base.theme,
  ...lightTheme.theme,
};
